export default __webpack_public_path__ + "static/media/hatefulstrikes.4dee2ea7.png";